// @ts-nocheck
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import GatewayChip from './GatewayChip.jsx';
import SmartLockChip from './SmartLockChip.jsx';
import { getPcuGatewayDisplay } from './powerControlUnitGatewayUtils.js';
import { resolveTriggerLocksByIds } from './powerControlUnitTriggerLockUtils.js';

const itemStyle = { color: '#5f5f5f', paddingLeft: 10, marginBottom: 4 };
const sectionTitleStyle = { fontWeight: 'bold', fontSize: 14, color: '#3f3f3f', marginBottom: 8 };
const sectionWrapStyle = { marginTop: 15 };
const triggerLockChipsWrapStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  paddingLeft: 10,
  marginBottom: 4,
};

function resolveAccessoryLabel(id, accessories) {
  const accessory = _.find(accessories, { id });
  if (accessory && accessory.name) {
    return accessory.name;
  }
  return `ID: ${id}`;
}

function renderIdList(ids, accessories) {
  if (!ids || ids.length === 0) {
    return null;
  }
  return ids.map(id => (
    <div key={id} style={itemStyle}>
      • {resolveAccessoryLabel(id, accessories)}
    </div>
  ));
}

@connect(state => ({
  locks: state.locks.data.content,
  accessories: state.accessories.data.content,
}))
class PowerControlUnitHardwareDevicesView extends React.Component {
  renderSection(titleEntity, content, marginTop = sectionWrapStyle.marginTop) {
    if (!content) {
      return null;
    }
    return (
      <div style={{ ...sectionWrapStyle, marginTop }}>
        <h5 style={sectionTitleStyle}>
          <Entity entity={titleEntity} />
        </h5>
        {content}
      </div>
    );
  }

  renderGatewayChip(selectedPCU, onGatewayClick) {
    const { label, gatewayId } = getPcuGatewayDisplay(selectedPCU);
    return (
      <div style={{ marginLeft: 10 }}>
        <GatewayChip
          label={label}
          gatewayId={gatewayId}
          onClick={onGatewayClick}
        />
      </div>
    );
  }

  renderTriggerLockChips(lockIds, pcuLockObjects, onLockClick) {
    const { locks } = this.props;
    const resolvedLocks = resolveTriggerLocksByIds(lockIds, pcuLockObjects, locks);
    if (!resolvedLocks || resolvedLocks.length === 0) {
      return null;
    }
    return (
      <div style={triggerLockChipsWrapStyle}>
        {resolvedLocks.map(lock => (
          <SmartLockChip
            key={lock.id}
            label={lock.name}
            lockId={lock.id}
            onClick={onLockClick}
          />
        ))}
      </div>
    );
  }

  render() {
    const { selectedPCU, accessories, onGatewayClick, onLockClick } = this.props;

    if (!selectedPCU || !selectedPCU.id) {
      return null;
    }

    const { hasGateway } = getPcuGatewayDisplay(selectedPCU);
    const relayIds = selectedPCU.relayAccessoryIds || [];
    const doorSensorIds = selectedPCU.doorSensorAccessoryIds || [];
    const triggerLockOnIds = selectedPCU.triggerLockOnIds || [];
    const triggerLockOffIds = selectedPCU.triggerLockOffIds || [];
    const triggerLocksOn = selectedPCU.triggerLocksOn || selectedPCU.triggerLocks || [];
    const triggerLocksOff = selectedPCU.triggerLocksOff || [];
    const presenceSensorId = selectedPCU.presenceSensorAccessoryId;

    const hasRelays = relayIds.length > 0;
    const hasDoorSensors = doorSensorIds.length > 0;
    const hasTriggerLocksOn = triggerLockOnIds.length > 0;
    const hasTriggerLocksOff = triggerLockOffIds.length > 0;
    const hasPresenceSensor = presenceSensorId !== undefined && presenceSensorId !== null;
    const hasDevices = hasGateway || hasRelays || hasDoorSensors || hasTriggerLocksOn
      || hasTriggerLocksOff || hasPresenceSensor;

    return (
      <FormFlatContainer title="hardwareDevices" subtitle="hardwareDevicesDescription" containerStyle={{ marginRight: 10 }}>
        {!hasDevices && (
          <h5 style={{ margin: 0, color: '#666' }}>-</h5>
        )}
        {this.renderSection(
          'controllingGateway',
          hasGateway ? this.renderGatewayChip(selectedPCU, onGatewayClick) : null,
          10,
        )}
        {this.renderSection('smartRelaysPCU', renderIdList(relayIds, accessories))}
        {this.renderSection(
          'presenceSensor',
          hasPresenceSensor ? <div style={itemStyle}>{resolveAccessoryLabel(presenceSensorId, accessories)}</div> : null,
        )}
        {this.renderSection('doorSensors', renderIdList(doorSensorIds, accessories))}
        {(hasTriggerLocksOn || hasTriggerLocksOff) && this.renderSection('triggerLocks', (
          <div>
            {hasTriggerLocksOn && (
              <div>
                <h5 style={{ fontSize: 13, color: '#666', margin: '0 0 6px 10px' }}>
                  <Entity entity="powerOn" />
                </h5>
                {this.renderTriggerLockChips(triggerLockOnIds, triggerLocksOn, onLockClick)}
              </div>
            )}
            {hasTriggerLocksOff && (
              <div style={{ marginTop: hasTriggerLocksOn ? 10 : 0 }}>
                <h5 style={{ fontSize: 13, color: '#666', margin: '0 0 6px 10px' }}>
                  <Entity entity="powerOff" />
                </h5>
                {this.renderTriggerLockChips(triggerLockOffIds, triggerLocksOff, onLockClick)}
              </div>
            )}
          </div>
        ))}
      </FormFlatContainer>
    );
  }
}

export default PowerControlUnitHardwareDevicesView;
